import { useTranslation } from "react-i18next";

import { Card } from "../../components";
import { news } from "./newsData";
import NewsList from "./NewsList";
import NoNews from "./NoNews";

const News = () => {
    const { t } = useTranslation();

    return (
        <Card
            title={t("Dashboard##title##news")}
            containerCustomStyle={{
                flex: "1",
                display: "flex",
                flexDirection: "column",
                overflowY: "hidden",

                "@media (max-width: 1099px)": {
                    maxHeight: "534px"
                }
            }}
            bodyCustomStyle={{
                display: "flex",
                flexDirection: "column",
                overflowY: "hidden"
            }}
        >
            {news.length === 0 ? <NoNews /> : <NewsList />}
        </Card>
    );
};

export default News;
